import api from './api';

export const facilitiesAPI = {
  getAll: (params = {}) => api.get('/facilities', { params }),
  getOne: (id) => api.get(`/facilities/${id}`),
  create: (data) => api.post('/facilities', data),
  update: (id, data) => api.put(`/facilities/${id}`, data),
  delete: (id) => api.delete(`/facilities/${id}`),
};